import { render, staticRenderFns } from "./AnnouncementContainer.vue?vue&type=template&id=9f0c624a&scoped=true&"
import script from "./AnnouncementContainer.vue?vue&type=script&lang=js&"
export * from "./AnnouncementContainer.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementContainer.vue?vue&type=style&index=0&id=9f0c624a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0c624a",
  null
  
)

export default component.exports